import Button, { ButtonProps } from "@mui/material/Button";
import { ElementType, forwardRef } from "react";

/** Extends MUI Button props with common polymorphic link fields. */
export type AppButtonProps = ButtonProps & {
  component?: ElementType;
  to?: string;
  href?: string;
};

/**
 * Shared button. Theme defaults (height, radius, sentence case, no elevation)
 * come from ThemeManager; this wrapper is the single import path for pages.
 */
export const AppButton = forwardRef<HTMLButtonElement, AppButtonProps>(
  function AppButton({ disableElevation = true, ...props }, ref) {
    return <Button ref={ref} disableElevation={disableElevation} {...props} />;
  }
);

export default AppButton;
